import React from 'react'

import './Loader.css'

const Loader = () => (
  <div className="loader"><div /></div>
)

export default Loader


// WEBPACK FOOTER //
// ./src/components/Loader.js